import { getData } from './request';
import type { ClientSideAvailablePlatformConfigKeys } from '@cutr/constants/platform-config';

export type FrontendPlatformConfig = Record<
  ClientSideAvailablePlatformConfigKeys,
  unknown
>;

export function getFrontendPlatformConfig(signal?: AbortSignal) {
  return getData<FrontendPlatformConfig>('/v2/platform-config/frontend', {
    signal,
  });
}
